"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const AlertDialog_1 = __importDefault(require("../AlertDialog"));
const DatePicker_1 = __importDefault(require("../DatePicker"));
const AlertDialogDataNascimento = (_a) => {
    var { open, handleClose, handleAvancar } = _a, dialogProps = __rest(_a, ["open", "handleClose", "handleAvancar"]);
    const [dataNasc, setDataNasc] = react_1.useState(null);
    const [dataValida, setDataValida] = react_1.useState(false);
    react_1.useEffect(() => {
        if (dataNasc) {
            if (isNaN(dataNasc.getDate())) {
                setDataValida(false);
            }
            else {
                setDataValida(true);
            }
        }
        else {
            setDataValida(false);
        }
    }, [dataNasc]);
    const handleAvancarWrapper = () => {
        if (dataValida) {
            handleAvancar(dataNasc);
        }
    };
    const DialogContent = () => (react_1.default.createElement(Box_1.default, { mb: 4 },
        react_1.default.createElement(DatePicker_1.default, { label: "Digite sua data de nascimento", valor: dataNasc, onChange: setDataNasc, enterHandler: handleAvancarWrapper })));
    return (react_1.default.createElement(AlertDialog_1.default, Object.assign({}, dialogProps, { open: open, handleClose: handleClose, handleAvancar: handleAvancarWrapper, titulo: "Autentica\u00E7\u00E3o", btnAvancarDisabled: !dataValida, maxWidth: "md", fullWidth: true }),
        react_1.default.createElement(DialogContent, null)));
};
exports.default = AlertDialogDataNascimento;
//# sourceMappingURL=index.js.map